document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mobile-toggle]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const menu=document.querySelector('[data-mobile-menu]');
      if(!menu)return;
      const open=menu.hasAttribute('hidden');
      if(open){menu.removeAttribute('hidden');menu.style.display='block';btn.setAttribute('aria-expanded','true')}
      else{menu.setAttribute('hidden','');menu.style.display='none';btn.setAttribute('aria-expanded','false')}
    });
  });

  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const jsonEl=section.querySelector('[data-product-variants]');
    const selectedJson=section.querySelector('[data-selected-options]');
    const idInput=section.querySelector('[data-variant-id]');
    const priceEl=section.querySelector('[data-current-price]');
    const compareEl=section.querySelector('[data-compare-price]');
    const availability=section.querySelector('[data-availability]');
    const add=section.querySelector('[data-add-to-cart]');
    if(!jsonEl||!idInput)return;

    let variants=[];
    let selected=[];
    try{variants=JSON.parse(jsonEl.textContent)}catch(e){return}
    try{selected=selectedJson?JSON.parse(selectedJson.textContent):[]}catch(e){selected=[]}

    const optionGroups=[...section.querySelectorAll('[data-option-group]')];
    optionGroups.forEach(group=>{
      const idx=Number(group.dataset.optionIndex||0);
      if(!selected[idx]){
        const active=group.querySelector('[data-option-button].is-selected');
        if(active)selected[idx]=active.dataset.optionValue;
      }
    });

    const showMedia=(mediaId)=>{
      if(!mediaId)return;
      const gallery=section.querySelector('[data-product-gallery]');
      if(!gallery)return;
      const panels=[...gallery.querySelectorAll('[data-media-panel]')];
      const thumbs=[...gallery.querySelectorAll('[data-media-thumb]')];
      const target=String(mediaId);
      let found=false;
      panels.forEach(panel=>{
        const active=panel.dataset.mediaPanel===target;
        panel.hidden=!active;
        panel.classList.toggle('is-active',active);
        if(active)found=true;
      });
      if(found){thumbs.forEach(t=>t.classList.toggle('is-active',t.dataset.mediaThumb===target))}
    };

    section.querySelectorAll('[data-media-thumb]').forEach(thumb=>{
      thumb.addEventListener('click',()=>showMedia(thumb.dataset.mediaThumb));
    });

    const money=(cents)=>window.Shopify&&Shopify.formatMoney?Shopify.formatMoney(cents):'$'+(cents/100).toFixed(2);

    const updateVariant=({fromColor=false,colorMediaId=null}={})=>{
      const variant=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!variant)return;
      idInput.value=variant.id;
      if(priceEl)priceEl.textContent=money(variant.price);
      if(compareEl){
        if(variant.compare_at_price&&variant.compare_at_price>variant.price){compareEl.textContent=money(variant.compare_at_price);compareEl.hidden=false}
        else compareEl.hidden=true;
      }
      if(add){add.disabled=!variant.available;add.textContent=variant.available?'Add to cart':'Sold out'}
      if(availability){availability.innerHTML=variant.available?'<span class="status-dot"></span>In stock':'Sold out'}
      const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);

      let preferredMedia=null;
      if(variant.featured_media&&variant.featured_media.id)preferredMedia=variant.featured_media.id;
      else if(variant.featured_image&&variant.featured_image.id)preferredMedia=variant.featured_image.id;
      else if(fromColor&&colorMediaId)preferredMedia=colorMediaId;
      if(preferredMedia)showMedia(preferredMedia);
    };

    section.querySelectorAll('[data-option-button]').forEach(button=>{
      button.addEventListener('click',()=>{
        const idx=Number(button.dataset.optionIndex||0);
        selected[idx]=button.dataset.optionValue;
        const group=button.closest('[data-option-group]');
        if(group){
          group.querySelectorAll('[data-option-button]').forEach(b=>{const active=b===button;b.classList.toggle('is-selected',active);b.setAttribute('aria-pressed',active?'true':'false')});
          const label=group.querySelector('[data-selected-option-value]');
          if(label)label.textContent=button.dataset.optionValue;
        }
        updateVariant({fromColor:button.hasAttribute('data-color-media-id'),colorMediaId:button.dataset.colorMediaId||null});
      });
    });

    const activeColor=section.querySelector('[data-color-media-id].is-selected');
    updateVariant({fromColor:!!activeColor,colorMediaId:activeColor?activeColor.dataset.colorMediaId:null});

    const qty=section.querySelector('[data-quantity]');
    section.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{if(!qty)return;qty.value=Math.max(1,Number(qty.value||1)-1)});
    section.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{if(!qty)return;qty.value=Math.max(1,Number(qty.value||1)+1)});
  });
});
